/* eslint no-shadow: 0 */
import mbcService from '@/service/mbcService';

export const namespaced = true;

export const state = {
  surveyTemplateData: null,
  labelingInformation: null,
  showFinishPopup: false // 記名問卷完成後回訪頁調整
};

export const getters = {
};

export const mutations = {
  setFormData(state, data) {
    state[data.id] = data.value;
  }
};

export const actions = {
  postMemberTag({ state }, companyTagNo) {
    const body = { ...state.labelingInformation };

    body.companyTagNo = companyTagNo;

    return mbcService.postMemberTag(body);
  }
};
